/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The type of the question condition

Values: question=QUESTION, variable=VARIABLE
 * @export
 * @enum {string}
 */

export enum QuestionConditionTypeEnum {
    QUESTION = 'question',
    VARIABLE = 'variable'
}


